export const mutationKeys = {
  addresses: {
    index: 'addresses',
    update: (addressId: number) => [mutationKeys.addresses.index, addressId],
  },
  carts: {
    index: 'carts',
    create: () => [mutationKeys.carts.index, 'create'],
    addItemToCart: (cartId: number) => [
      mutationKeys.carts.index,
      cartId,
      'addItemToCart',
    ],
    deleteCartItem: (cartId: number) => [
      mutationKeys.carts.index,
      cartId,
      'deleteCartItem',
    ],
    delete: (cartId: number) => [mutationKeys.carts.index, cartId, 'delete'],
    updatePeriod: (cartId: number) => [
      mutationKeys.carts.index,
      cartId,
      'updatePeriod',
    ],
    validatePromoCode: (cartId: number) => [
      mutationKeys.carts.index,
      cartId,
      'validatePromoCode',
    ],
    buyAgain: (cartId: number) => [
      mutationKeys.carts.index,
      cartId,
      'buyAgain',
    ],
    done: (cartId: number) => [mutationKeys.carts.index, cartId, 'done'],
  },
  checkout: {
    index: 'checkout',
    create: () => [mutationKeys.checkout.index, 'create'],
  },
  promoCodes: {
    index: 'promo-codes',
    create: () => [mutationKeys.promoCodes.index, 'create'],
    update: () => [mutationKeys.promoCodes.index, 'update'],
    delete: (code: string) => [mutationKeys.promoCodes.index, 'delete', code],
    send: () => [mutationKeys.promoCodes.index, 'send'],
  },
  orders: {
    index: 'orders',
    updateState: (orderId?: number) =>
      orderId !== undefined
        ? [mutationKeys.orders.index, 'updateState', orderId]
        : [mutationKeys.orders.index, 'updateState'],
    updateNote: (orderId?: number) =>
      orderId !== undefined
        ? [mutationKeys.orders.index, 'updateNote', orderId]
        : [mutationKeys.orders.index, 'updateNote'],
    setParcel: (orderId?: number) =>
      orderId !== undefined
        ? [mutationKeys.orders.index, 'setParcel', orderId]
        : [mutationKeys.orders.index, 'setParcel'],
  },
  invitations: {
    index: 'invitations',
    create: () => [mutationKeys.invitations.index, 'create'],
    delete: (uuid: string) => [mutationKeys.invitations.index, 'delete', uuid],
    sendReminder: (uuid: string) => [
      mutationKeys.invitations.index,
      'sendReminder',
      uuid,
    ],
  },
  clinics: {
    index: 'clinics',
    create: () => [mutationKeys.clinics.index, 'create'],
    update: () => [mutationKeys.clinics.index, 'update'],
    delete: () => [mutationKeys.clinics.index, 'delete'],
  },
  warningPatterns: {
    index: 'warning-patterns',
    create: () => [mutationKeys.warningPatterns.index, 'create'],
    update: () => [mutationKeys.warningPatterns.index, 'update'],
    delete: () => [mutationKeys.warningPatterns.index, 'delete'],
  },
  users: {
    index: 'users',
    update: () => [mutationKeys.users.index, 'update'],
    delete: (id: number) => [mutationKeys.users.index, 'delete', id],
  },
  adminIngredients: {
    index: 'admin-ingredients',
    create: () => [mutationKeys.adminIngredients.index, 'create'],
    update: () => [mutationKeys.adminIngredients.index, 'update'],
    delete: () => [mutationKeys.adminIngredients.index, 'delete'],
  },
  stock: {
    index: 'stock',
    add: () => [mutationKeys.stock.index, 'add'],
    update: () => [mutationKeys.stock.index, 'update'],
  },
  doctorPatients: {
    index: 'doctor-patients',
    assign: () => [mutationKeys.doctorPatients.index, 'assign'],
    unassign: () => [mutationKeys.doctorPatients.index, 'unassign'],
  },
  adminPatientCarts: {
    index: 'admin-patient-carts',
    create: () => [mutationKeys.adminPatientCarts.index, 'create'],
  },
  adminQrCodes: {
    index: 'admin-qr-codes',
    create: () => [mutationKeys.adminQrCodes.index, 'create'],
  },
  tempOrders: {
    index: 'temp-orders',
    createCustomer: () => [mutationKeys.tempOrders.index, 'create-customer'],
    createOrder: () => [mutationKeys.tempOrders.index, 'create-order'],
  },
  adminQrCodeNotes: {
    index: 'admin-qr-code-notes',
    create: () => [mutationKeys.adminQrCodeNotes.index, 'create'],
    update: (id?: number) =>
      id !== undefined
        ? [mutationKeys.adminQrCodeNotes.index, 'update', id]
        : [mutationKeys.adminQrCodeNotes.index, 'update'],
    delete: (id?: number) =>
      id !== undefined
        ? [mutationKeys.adminQrCodeNotes.index, 'delete', id]
        : [mutationKeys.adminQrCodeNotes.index, 'delete'],
  },
  parcels: {
    index: 'parcels',
    create: () => [mutationKeys.parcels.index, 'create'],
  },
  adminMaintenance: {
    index: 'admin-maintenance',
    toggle: () => [mutationKeys.adminMaintenance.index, 'toggle'],
  },
  adminItems: {
    index: 'admin-items',
    create: () => [mutationKeys.adminItems.index, 'create'],
    update: () => [mutationKeys.adminItems.index, 'update'],
    delete: () => [mutationKeys.adminItems.index, 'delete'],
    prices: {
      index: 'prices',
      create: (itemId: number) => [
        mutationKeys.adminItems.index,
        itemId,
        mutationKeys.adminItems.prices.index,
        'create',
      ],
      update: (itemId: number, priceId: number) => [
        mutationKeys.adminItems.index,
        itemId,
        mutationKeys.adminItems.prices.index,
        priceId,
        'update',
      ],
      delete: (itemId: number, priceId: number) => [
        mutationKeys.adminItems.index,
        itemId,
        mutationKeys.adminItems.prices.index,
        priceId,
        'delete',
      ],
    },
  },
};
